module.exports = __webpack_public_path__ + "media/images/marker-438ba45a2f292b34f7134d46501aca57.png";